export default __webpack_public_path__ + "static/media/Bathroom.78703c81.png";